export default {
  state: {
    favoriteList: [],
    cartList: []
  },
  mutations: {
    SET_FAVORITE: (state, favoriteList) => {
      state.favoriteList = favoriteList
    },
    SET_CART: (state, cartList) => {
      state.cartList = cartList
    },
    REMOVE_FAVORITE: (state, favoriteItem) => {
      const itemIdex = state.favoriteList.findIndex(item => item.id === favoriteItem.id)
      state.favoriteList.splice(itemIdex, 1)
    },
    REMOVE_CART: (state, cartItem) => {
      const itemIdex = state.cartList.findIndex(item => item.id === cartItem.id)
      state.cartList.splice(itemIdex, 1)
    }
  },
  actions: {
    addFavoriteList ({ commit }, favoriteList) {
      commit('SET_FAVORITE', favoriteList)
    },
    addCartList ({ commit }, cartList) {
      commit('SET_CART', cartList)
    },
    removeFavoriteItem ({ commit }, favoriteItem) {
      commit('REMOVE_FAVORITE', favoriteItem)
    },
    removeCartItem ({ commit }, cartItem) {
      commit('REMOVE_CART', cartItem)
    }
  }
}
